import React from 'react'
import { Grid,InputBase,TextField,Input, Button,ListItem, List,Typography, ListItemIcon, Icon } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grow from '@material-ui/core/Grow';
import searchFunction from './Search';
import PageIcon from '@material-ui/icons/InsertDriveFileOutlined';



export default class SearchBox extends React.Component{
    constructor(props){
        super(props)
        this.state={
          focus:false,
          searchText:''
        }
        this.searchBox=React.createRef();
    }
    componentDidMount(){
      if(window.screen.width<=500){
        if(this.searchBox.current){
          this.searchBox.current.focus();
        }
      }
    }
    noResultsFound=()=>{
      return <div style={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
        <img src='/no-data.png' style={{width:'30%'}} />
        </div>
    }
    getSearchResult=()=>{
      if(this.state.searchText=='')return null;
      let results=searchFunction(this.state.searchText);
      let message=''
      if(results.length==0){
        message = <Typography>Sorry no results for `{this.state.searchText}` !</Typography>
        results = this.noResultsFound();
      }else{
          results=results.map((t)=>{
            return <ListItem component={Button} href={t.link} onClick={()=>{window.location.href=t.link}}>
                    <ListItemIcon ><PageIcon/></ListItemIcon>
                    {t.name}
            </ListItem>
          })
          results=<List>{results}</List>;
          message=<Typography>Showing results for {this.state.searchText}</Typography>
      }
      let desktopStyle={ borderRadius:'33px',borderTopRightRadius:0,borderTopLeftRadius:0, position: 'absolute',left: '45%',right: '0',background: 'white',top: '64px',bottom: '-260px',border: '1px solid #8080802b',borderTop: 'none',listStyle: 'none',padding:'30px'};
      let mobileStyle={ borderRadius:'33px',borderTopRightRadius:0,borderTopLeftRadius:0, position: 'absolute',left: '0',right: '0',background: 'white',top: '50px',bottom: '-260px',border: '1px solid #8080802b',borderTop: 'none',listStyle: 'none',padding:'30px'}
      let style=desktopStyle;
      if(window.screen.width<=768){
        style=mobileStyle;
      }
    results=<div style={style}>
      {message}{results}
    </div>
    return results;
    }
    render(){
      let width=200;
      if(this.state.focus){
          width=300;
      }
      if(this.props.width){
        width=this.props.width
      
      }
      let searchResult = this.getSearchResult();
      let onBlur=()=>{
        if(window.screen.width<768  && searchResult!=null )return;
        if(this.props.onBlur){
          this.props.onBlur();
        }else{
          this.setState({focus:false})
          }
      }
        return        <> <Grow
          in={true}
          style={{ transformOrigin: '0 0 0' }}
          {...{ timeout: 1000 }}
        >
           <Input defaultValue="" inputProps={{ 'aria-label': 'description' }} disableUnderline 
           inputRef={ this.searchBox} placeholder='Search'
           onChange={(e)=>{
             this.setState({searchText:e.target.value})
           }}
           style={{
             width:width,
            background: '#d3d3d352',
            padding: '5px',
            borderRadius: '50px'
           }}
           onFocus={()=>{this.setState({focus:true})}}
           onBlur={onBlur}
           startAdornment={<InputAdornment position="start"><SearchIcon/></InputAdornment>}
           />
        </Grow>
        {searchResult}
        </>
    }
}
